import { traverseNode, isElementNode, removeSetOfNodes, isOneOfTags } from 'anodum';
import handleMediaElement from './handle-media-element';
import unwrapElement from './unwrap-element';
import isMediaElement from '../verifiers/is-media-element';
import isElementToRemove from '../verifiers/is-element-to-remove';
import isElementToUnwrap from '../verifiers/is-element-to-unwrap';
import isElementToWrap from '../verifiers/is-element-to-wrap';
import isLink from '../verifiers/is-link';
import convertElementToSupported from './convert-element-to-supported';
import { DEFAULT_BLOCK_TAG, SUPPORTED_ELEMENTS } from '../constants/editable-elements';
import removeUnsupportedAttributes from './remove-unsupported-attributes';
import wrapIntoElement from './wrap-into-element';
import normalizeStyleAttribute from './normalize-style-attribute';
import handleMediaSiblings from './handle-media-siblings';
import handleNestedMediaContent from './handle-nested-media-content';
import handleLinkElement from './handle-link-element';
import handleListItemsAfterClipboardPreparation from './handle-list-items-after-clipboard-preparation';
import removeUnsupportedClassNames from './remove-unsupported-class-names';

const prepareStructure = (element) => {
  const rootElement = element;
  const mediaElements = [];
  const linkElements = [];
  const elementsToRemove = [];
  const elementsToUnwrap = [];
  const elementsToWrap = [];
  const elementsToConvert = [];

  handleNestedMediaContent(rootElement);

  traverseNode(rootElement, (node) => {
    if (node === rootElement) return;

    if (isElementNode(node)) {
      removeUnsupportedAttributes(node);
      removeUnsupportedClassNames(node);
    }

    const lastElementToRemove = elementsToRemove[elementsToRemove.length - 1];
    const lastMediaElement = mediaElements[mediaElements.length - 1];
    if (
      (lastElementToRemove && lastElementToRemove.contains(node)) ||
      (lastMediaElement && lastMediaElement.contains(node))
    )
      return;

    if (isElementToRemove(node)) {
      elementsToRemove.push(node);
      return;
    }

    if (isElementToWrap(node, rootElement)) {
      elementsToWrap.push(node);
      return;
    }

    if (isElementToUnwrap(node)) {
      elementsToUnwrap.push(node);
      return;
    }

    if (isMediaElement(node)) {
      mediaElements.push(node);
      return;
    }

    if (isLink(node)) {
      linkElements.push(node);
      normalizeStyleAttribute(node);
      return;
    }

    if (isElementNode(node)) {
      if (!isOneOfTags(node, SUPPORTED_ELEMENTS)) {
        elementsToConvert.push(node);
        return;
      }
      normalizeStyleAttribute(node);
    }
  });

  removeSetOfNodes(elementsToRemove);
  elementsToUnwrap.forEach(unwrapElement);
  elementsToWrap.forEach((el) => wrapIntoElement(el, DEFAULT_BLOCK_TAG, true));
  elementsToConvert.forEach(convertElementToSupported);
  mediaElements.map(handleMediaElement).forEach(handleMediaSiblings);
  linkElements.forEach(handleLinkElement);

  handleListItemsAfterClipboardPreparation(rootElement);
};

export default prepareStructure;
